import React from 'react';
import { InputCounter, InputCounterModifier } from '../../../../../../_lib/Form2/partials/InputCounter/InputCounter';

type EditorInputCounterProps = {
  maxLength: number | 0; // without HTML, i.e. stripped tags
  currentCount: number;
  children: React.ReactNode;
};

export default function EditorInputCounter({ maxLength, currentCount, children }: EditorInputCounterProps) {
  return (
    <>
      {children}
      {maxLength > 0 && (
        <InputCounter currentCount={currentCount} maxLength={maxLength} modifier={InputCounterModifier.VISIBLE} />
      )}
    </>
  );
}
